import { styled } from '@mui/material';

export const StyledContainer = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingTop: '100px',
    paddingBottom: '100px',
  };
});

export const StyledTitle = styled('div')(() => {
  return {
    paddingTop: '20px',
    paddingBottom: '60px',
  };
});

export const StyledCardsWrapper = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: '12px',
    flexWrap: 'wrap',

    '@media (max-width: 1295px)': {
      gap: '32px',
    },
  };
});

export const StyledThreeCards = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flex: 1,
    gap: '12px',
  };
});
